<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalTracingsVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(autofocus :placeholder='$t("sale_tracings.text_placeholder")' :danger="$v.form.text.$invalid" :danger-text="$t('validation.required', { attribute: $t('sale_tracings.text') })" v-model="form.text" :label='$t("sale_tracings.text")')
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalSaleTracings',
  props: {
    sale_id: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    form: {}
  }),
  validations: {
    form: {
      text: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalTracingsVisible'
    ]),
    getTitle () {
      return this.$t('sale_tracings.add')
    }
  },
  methods: {
    ...mapActions([
      'setModalTracingsVisible',
      'addSaleTracing'
    ]),
    saveRecord () {
      this.form.sale_id = this.sale_id
      this.addSaleTracing(this.form)
      this.form = {}
    },
    close () {
      this.setModalTracingsVisible(false)
    }
  }
}
</script>
